var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"#","title":"Switch user"},on:{"click":_vm.openModal}},[_c('i',{staticClass:"fa fa-user-friends fa-fw"}),_vm._v(" Switch user\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }